import { palette } from '@livable/saas-react-components';
const MuiTooltip = {
  styleOverrides: {
    tooltip: {
      backgroundColor: palette.shades[800],
      fontSize: '15px',
      lineHeight: '20px',
      margin: '0',
      marginBottom: '14px',
      padding: '12px 18px',
      maxWidth: '420px',
      boxShadow: palette.shadows.header,
      color: palette.shades[100],
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
      '& .MuiSvgIcon-root': {
        marginRight: '4px',
        marginLeft: '-4px'
      }
    },
    popper: {
      zIndex: '130050'
    }
  }
};
export default MuiTooltip;